import { render, staticRenderFns } from "./403.vue?vue&type=template&id=bf40c9dc&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"
import style0 from "./Error.scss?vue&type=style&index=0&id=bf40c9dc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf40c9dc",
  null
  
)

export default component.exports